module.exports = __webpack_public_path__ + "img/logo-XVI-3er-anio-horizontal.15baafe0.svg";